import React, { useState } from 'react';
import { InfoPanel } from '../..';
import Button from '@atlaskit/button';
import './sign-up-banner.scss';

interface SignUpBannerProps {
  email: string;
  handleCreateAtlassianAccount: () => void;
}

export const SignUpBanner = ({ email, handleCreateAtlassianAccount }: SignUpBannerProps) => {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const needAtlassianAccountTitle = 'This email is not registered as an Atlassian account';
  const needAtlassianAccountMessage = (
    <>
      {isDetailsVisible && (
        <div>
          Select <span className="fw-6">Create Atlassian account</span> to register this email address. We’ll send an
          email to <span className="fw-6">{email}</span> so they can verify their email and complete the signup process.
        </div>
      )}
      <div className="action-buttons">
        <Button
          appearance="link"
          testId={`create-account-${email}`}
          onClick={() => {
            handleCreateAtlassianAccount();
          }}
          spacing="none"
        >
          Create Atlassian account
        </Button>
        <div className="dot-text">.</div>
        <Button
          appearance="link"
          testId={`view-more-${email}`}
          onClick={() => {
            setIsDetailsVisible(!isDetailsVisible);
          }}
          spacing="none"
        >
          {isDetailsVisible ? 'Read less' : 'Read more'}
        </Button>
      </div>
    </>
  );
  return (
    <div className="sign-up-banner" data-testid={`sign-up-banner-${email}`}>
      <InfoPanel type="warning" title={needAtlassianAccountTitle} message={needAtlassianAccountMessage}></InfoPanel>
    </div>
  );
};
